module.exports = __webpack_public_path__ + "img/Cote D’ivoire.13e9e166.png";